import { render, staticRenderFns } from "./TablaPivotPreciosTodosLosTipos.vue?vue&type=template&id=bebfaf74"
import script from "./TablaPivotPreciosTodosLosTipos.vue?vue&type=script&lang=js"
export * from "./TablaPivotPreciosTodosLosTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports